import React from 'react';
import { Flex, Row } from 'antd';
import { TagOutlined, UsergroupAddOutlined, CreditCardOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import SwitchShop from '../shop/switch-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        <SwitchShop />
        <Row gap={20} style={{ margin: '10px 0 0 0' }}>
            <NavItem href="/promotion/goods-card-template" text="次卡">
                <CreditCardOutlined style={iconStyle} />
            </NavItem>

            <NavItem href="/promotion/group-buy" text="团购">
                <UsergroupAddOutlined style={iconStyle} />
            </NavItem>

            <NavItem href="/promotion/coupon" text="优惠券">
                <TagOutlined style={iconStyle} />
            </NavItem>

            {/* <NavItem href="/category" text="类目管理">
                <AppstoreAddOutlined style={iconStyle} />
            </NavItem> */}
        </Row>
        
        {/* <List /> */}
    </div>
  )
}